export const SLICE_BILAN_BLOC = "bilan_bloc";
export const SLICE_THREE_REASONS_CONSULYTATION = "three_reasons_consultation";
export const SLICE_FIXED_BOTTOM_BAR = "fixed_bottom_bar";
export const SLICE_ITEM_SELECT_INFO = "Info Bloc";
export const SLICE_PROGRAM_POPUP = "program_popup";
export const SLICE_ITEM_SELECT_PROVEN = "Proven effectiveness Bloc";
export const CUSTOM_TYPE_TESTIMONIAL_STAGING = "avis_staging";
export const CUSTOM_TYPE_TESTIMONIAL_PROD = "avis";
export const SLICE_OFFERED_PRODUCT = "offered_products";
export const SLICE_CARD_ADVANTAGE = "cart_advantages";
export const SLICE_DIET_ADVICE = "my_diet_advice";
export const SLICE_HEAD_TEXT = "meals_head_text";
